/**
 * lib/goodwillApi.js — admin Goodwill Credit Audit endpoints.
 */
import api, { formatApiError } from "./api";

export async function getGoodwillSummary(days = 30) {
  return (await api.get(`/admin/diploks/system-credits/summary?days=${days}`)).data;
}

export async function getGoodwillList({
  days = 30, userId = null, featureKey = null, limit = 200,
} = {}) {
  const p = new URLSearchParams();
  p.set("days", String(days));
  p.set("limit", String(limit));
  if (userId) p.set("user_id", userId);
  if (featureKey) p.set("feature_key", featureKey);
  return (await api.get(`/admin/diploks/system-credits/list?${p.toString()}`)).data;
}

export function goodwillCsvUrl(days = 30) {
  return `/admin/diploks/system-credits/export.csv?days=${days}`;
}

export { formatApiError };
